<div class="absolute z-10 
  {{horisontalPositionClasses}}
  flex justify-center items-center rounded-full text-lg font-serif text-center  w-24 h-24 
  {{sticker.color ? sticker.color: 'bg-e-orange text-white'}}
" 
[ngClass]="{'-top-24 md:-top-9': moveUp, '-top-14 md:-top-6': !moveUp}"
>
  {{ sticker?.title }}
</div>